import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { REPORT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PendingSummaryPage } from '@/features/dashboards/pages/PendingSummaryPage';
import { pendingSummaryPageSearchSchema } from '@/features/dashboards/types/pendingSummary.types';

export const Route = createFileRoute('/_auth/dashboards/pending')({
  beforeLoad: () => requirePermission(REPORT_PERMISSIONS.PENDING_VIEW),
  validateSearch: pendingSummaryPageSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR & DER Pending">
      <Suspense fallback={<PageLoader />}>
        <PendingSummaryPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
